/* Shopify's preview iframe fills the viewport, but PBarNextFrameWrapper clips
 * it to the actual toolbar height. Measure that wrapper, never preview-session
 * flags: Shopify CLI can proxy those flags without displaying a toolbar. */
const previewBarClass = 'esim-preview-bar-visible';
const previewBarSelector = 'iframe[src*="/shopifycloud/preview-bar/"]';
const legacyPreviewBarHeight = 64;
const root = document.documentElement;

let updateQueued = false;
let observedBar = null;
const resizeObserver = new ResizeObserver(queuePreviewBarUpdate);

function visibleRect(element) {
  if (!element) return null;

  for (let node = element; node; node = node.parentElement) {
    const style = window.getComputedStyle(node);
    if (node.hidden || style.display === 'none' || style.visibility !== 'visible' || style.opacity === '0') {
      return null;
    }
  }

  const rect = element.getBoundingClientRect();
  return rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < window.innerHeight ? rect : null;
}

function previewBarOffset() {
  const frame = document.querySelector(previewBarSelector);
  const wrapper = frame?.closest('#PBarNextFrameWrapper');
  const bar = wrapper || frame;

  if (bar !== observedBar) {
    resizeObserver.disconnect();
    if (bar) resizeObserver.observe(bar);
    observedBar = bar;
  }

  if (new URLSearchParams(window.location.search).get('pb') === '0' || !visibleRect(frame)) return 0;

  const rect = visibleRect(bar);
  if (!rect) return 0;

  // Keep support for older preview bars without the clipping wrapper.
  return wrapper ? window.innerHeight - Math.max(0, rect.top) : Math.min(legacyPreviewBarHeight, rect.height);
}

function clearPreviewBarOffset() {
  if (root.classList.contains(previewBarClass)) {
    root.classList.remove(previewBarClass);
  }

  if (root.style.getPropertyValue('--esim-preview-bar-offset')) {
    root.style.removeProperty('--esim-preview-bar-offset');
  }
}

function setPreviewBarOffset(offset) {
  const offsetValue = `${offset}px`;

  if (root.style.getPropertyValue('--esim-preview-bar-offset') !== offsetValue) {
    root.style.setProperty('--esim-preview-bar-offset', offsetValue);
  }

  if (!root.classList.contains(previewBarClass)) {
    root.classList.add(previewBarClass);
  }
}

function updatePreviewBarState() {
  updateQueued = false;

  const offset = previewBarOffset();
  if (offset > 0) {
    setPreviewBarOffset(offset);
    return;
  }

  clearPreviewBarOffset();
}

function queuePreviewBarUpdate() {
  if (updateQueued) return;

  updateQueued = true;
  window.requestAnimationFrame(updatePreviewBarState);
}

new MutationObserver(queuePreviewBarUpdate).observe(root, {
  attributes: true,
  attributeFilter: ['class', 'hidden', 'style', 'src'],
  childList: true,
  subtree: true,
});

window.addEventListener('resize', queuePreviewBarUpdate);
queuePreviewBarUpdate();
